import { isCountryCode } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import getInitialCountry from './get-initial-country';

const getFormattedCountryLabels = (value: Array<string>): string =>
  value
    .filter((country: string) => isCountryCode(country))
    .map((country: string) => getInitialCountry(country as Iso3166TwoDigitCountryCode).label)
    .join(', ');

export default getFormattedCountryLabels;
